import { MaskOpts } from 'components/masked-number-input';

export const numberWithNounMask = (
  single: string,
  plural: string,
  pluralEx: string,
  params: { min: number; max: number },
) =>
  ({
    mask: [
      {
        mask: '',
      },
      {
        mask: 'num',
        lazy: false,
        blocks: {
          num: {
            mask: [
              {
                mask: `num ${single}`,
                lazy: false,
                blocks: {
                  num: {
                    mask: Number,
                    min: params.min,
                    max: params.max,
                  },
                },
              },
              {
                mask: `num ${pluralEx}`,
                lazy: false,
                blocks: {
                  num: {
                    mask: Number,
                    min: params.min,
                    max: params.max,
                  },
                },
              },
              {
                mask: `num ${plural}`,
                lazy: false,
                blocks: {
                  num: {
                    mask: Number,
                    min: params.min,
                    max: params.max,
                  },
                },
              },
            ],
            dispatch(appended, masked) {
              const number = parseInt(masked.value + appended);

              if (!number) return;

              const rem = number % 10;

              const ex = number > 20 || number < 10;

              if (ex && rem === 1) {
                return masked.compiledMasks[0];
              }

              if (ex && (rem === 2 || rem === 3 || rem === 4)) {
                return masked.compiledMasks[1];
              }

              return masked.compiledMasks[2];
            },
          },
        },
      },
    ],
  } as MaskOpts);
